import { FC } from 'react';
import { Container, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import { TermsThemeContainer } from '@bizapp-lp/workflow/molecules/TermsTheme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: '#FFFFFF 0% 0% no-repeat padding-box',
      boxShadow: '0px 16px 32px #00000014',
      borderRadius: '8px',
      padding: theme.spacing(10),
      [theme.breakpoints.down(768)]: {
        padding: theme.spacing(5),
      },
    },
    article: {
      wordWrap: 'break-word',
      '& > *:first-child': {
        marginTop: theme.spacing(7),
        paddingTop: 0,
      },
    },
    headerContent: {
      textAlign: 'right',
    },
  }),
);

export interface TermsProps {
  headerContent?: string | JSX.Element | JSX.Element[];
  className?: string;
  children: string | JSX.Element | JSX.Element[];
}

export const Terms: FC<TermsProps> = ({
  headerContent,
  children,
  className,
}) => {
  const classes = useStyles();
  return (
    <TermsThemeContainer
      maxWidth="md"
      className={`${classes.root} ${className ?? ''}`}
    >
      <Typography
        variant="subtitle1"
        component="p"
        className={classes.headerContent}
      >
        {headerContent}
      </Typography>
      <Container component="article" disableGutters className={classes.article}>
        {children}
      </Container>
    </TermsThemeContainer>
  );
};
